// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ITJS","type":"styles_type__1_fLX","choices":"styles_choices__1WDyn"};